import React from 'react';

const Terms = () => {
  return (
    <div className="dashboard-page fade-in">
      <div className="dashboard-head">
        <h1 className="dashboard-page-title legal-page-title">Terms of Service</h1>
        <p className="legal-page-meta">Last updated: January 2025</p>
      </div>

      <section className="card dashboard-section">
        <div className="dashboard-section-body">
          <div className="legal-content">
            <section className="legal-block">
              <h2 className="legal-heading">1. Acceptance of Terms</h2>
              <p className="legal-text">
                By accessing or using Coinspire, you agree to be bound by these Terms of Service
                and our Privacy Policy. If you do not agree to these terms, please do not use our platform.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">2. Eligibility</h2>
              <p className="legal-text">
                You must be at least 18 years old and have the legal capacity to enter into binding
                agreements to use Coinspire. You are responsible for ensuring that your use of the
                platform complies with all applicable laws and regulations in your jurisdiction.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">3. Account Registration</h2>
              <p className="legal-text">
                To access certain features, you must create an account and complete KYC verification.
                You agree to provide accurate, current, and complete information and to maintain and
                update your information as necessary.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">4. Risk Disclosure</h2>
              <p className="legal-text">
                Trading digital assets involves significant risk. Prices can be volatile, and you may
                lose your entire investment. You should carefully consider whether trading is suitable
                for you in light of your financial situation.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">5. Prohibited Activities</h2>
              <p className="legal-text">
                You may not use the platform for any illegal activities, market manipulation, money
                laundering, or any other prohibited activities as determined by Coinspire.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">6. Termination</h2>
              <p className="legal-text">
                We reserve the right to suspend or terminate your account at our sole discretion,
                without notice, for conduct that violates these terms or for other behavior that
                is harmful to the platform or other users.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">7. Contact Us</h2>
              <p className="legal-text">
                Questions about these Terms should be sent to{' '}
                <a href="mailto:legal@coinspire.com" className="legal-link">
                  legal@coinspire.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;